// Lesson picker — replaces the T9 "coming soon" placeholder that lived on the
// Play menu. It lists the registered `LESSON_SCRIPTS`; the registry is empty
// until T12 fills it, so today it shows an empty state. The launch wiring is
// live: once entries exist, tapping a row hands the canvas to the LessonScene
// via `ctx.startLesson` — T12 only adds data, no more wiring.
//
// Routing note: ui-shell's shared `Scene` union has no `lessons` member and is
// off-limits to this app-local task, so this screen is registered under the
// otherwise-unused `pre-game` scene value in main.ts.

import type { MenuScreen } from '../types.js';
import { createScreenShell, createMenuHeader, createCrestButton, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';
import { LESSON_SCRIPTS } from '../../lessons/scripts/index.js';

const translate = t as unknown as (key: string) => string;

export function createLessonListScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const body = shell.body;
      body.style.justifyContent = 'space-between';

      body.appendChild(createMenuHeader({ title: t('lesson.listTitle') }));

      const items =
        LESSON_SCRIPTS.length === 0
          ? [el('p', { class: 'about-paragraph', text: t('lesson.empty') })]
          : LESSON_SCRIPTS.map((script) =>
              createCrestButton({
                label: translate(script.titleKey),
                onClick: () => ctx.startLesson(script),
              }),
            );

      const center = el('div', { class: 'about-center' }, [
        el('div', { class: 'button-stack' }, items),
      ]);
      body.appendChild(center);

      const back = el('div', { class: 'button-row back-button-row' }, [
        createCrestButton({ label: t('common.back'), small: true, onClick: () => ctx.navigate('play') }),
      ]);
      body.appendChild(back);

      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
